import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { SettingsProvider } from "@/contexts/SettingsContext";
import { EnquiryCartProvider } from "@/contexts/EnquiryCartContext";
import { AdminAuthProvider, useAdminAuth } from "@/contexts/AdminAuthContext";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import EnquiryCart from "@/components/EnquiryCart";

import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";

function AdminRoute() {
    const { isAuthed, checking } = useAdminAuth();
    if (checking) return <div className="min-h-screen flex items-center justify-center text-muted-ink text-sm">Checking session…</div>;
    return isAuthed ? <Admin /> : <AdminLogin />;
}

function App() {
    return (
        <div className="App">
            <SettingsProvider>
                <EnquiryCartProvider>
                    <AdminAuthProvider>
                        <BrowserRouter>
                            <Navbar />
                            <main>
                                <Routes>
                                    <Route path="/" element={<Home />} />
                                    <Route path="/catalog" element={<Catalog />} />
                                    <Route path="/product/:id" element={<ProductDetail />} />
                                    <Route path="/about" element={<About />} />
                                    <Route path="/contact" element={<Contact />} />
                                    <Route path="/admin" element={<AdminRoute />} />
                                </Routes>
                            </main>
                            <Footer />
                            <EnquiryCart />
                            <WhatsAppFloat />
                        </BrowserRouter>
                    </AdminAuthProvider>
                    <Toaster
                        position="top-right"
                        theme="light"
                        toastOptions={{
                            style: { background: "#FBF8F1", border: "1px solid #E5DECB", color: "#1A1815" },
                        }}
                    />
                </EnquiryCartProvider>
            </SettingsProvider>
        </div>
    );
}

export default App;
